import React from 'react';
import { render } from 'react-dom';
import { SentryInit } from '@agilize/components-core';

import App from './App';

if (process.env.NODE_ENV === 'production') {
  SentryInit('https://34adcdb450c84254b7cbb7b1b66d2c1a@o569786.ingest.sentry.io/5965171', process.env.SENTRY_ENV || 'production');
}

// @ts-ignore
// eslint-disable-next-line camelcase,no-undef
__webpack_public_path__ = process.env.NODE_ENV === 'development' ? __webpack_public_path__ : `${process.env.APP_PATH}`;
render(<App />, document.getElementById('app_onboarding'));
